<mat-card-header>
    <mat-card-title class="text-uppercase text-left model-header news-modal-header">
        Sort Articles
    </mat-card-title>
    <div class="dialog-close">
        <button mat-button matSuffix mat-icon-button mat-dialog-close tabindex="-1">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
</mat-card-header>
<mat-card-content>
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
        <div *ngFor="let item of newsService.news | async">
        <div class="example-box"  cdkDrag *ngIf="item.catergories == 'News'">
            <div class="example-custom-placeholder" *cdkDragPlaceholder ></div>
            {{item.title}}
        </div>
        </div>
    </div>
</mat-card-content>
